import { combineReducers } from 'redux';

import {
  annotation,
  mainslat,
  notebook,
  noteslat,
  reader,
  sidePanel
} from './compModels';

import {
  bookmarks,
  highlights,
  markers,
  navigation,
  notes,
  notifications,
  selectedHighlight,
  toc,
  title,
  pageBreaks
} from './dataModels';


const rootReducer = combineReducers({
  title,
  annotation,
  bookmarks,
  highlights,
  markers,
  mainslat,
  navigation,
  notebook,
  notes,
  noteslat,
  notifications,
  reader,
  selectedHighlight,
  sidePanel,
  pageBreaks,
  toc,
});


export default rootReducer;
